import { render } from "./WidgetRendererEditorCmp.vue?vue&type=template&id=08490d60"
import script from "./WidgetRendererEditorCmp.vue?vue&type=script&lang=js"
export * from "./WidgetRendererEditorCmp.vue?vue&type=script&lang=js"

import "./WidgetRendererEditorCmp.vue?vue&type=style&index=0&id=08490d60&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__